import React, { useEffect } from 'react';
import { Form } from '@formio/react';
import useOperations from './componenteGenericoFormioFunctions';
import FormioFunctions from '../Precargas/FormIoFunctions';
import validacionesFormIoFunctions from '../validacionesFormIO/validacionesFormioFunctions';

export default function ComponenteGenericoFormio(props) {
    const { formData, getResource } = useOperations();
    const { obtenerUrlContexto } = FormioFunctions();
    const { functionValidadorRegex } = validacionesFormIoFunctions();


    useEffect(() => {
        getResource(props.aliasFormulario);
    }, []);

    return (
        <Form
            form={formData}
            onSubmit={props.onSubmit}
            options={{
                ov: true,
                language: 'sp',
                i18n: {
                    sp: {
                        ...props.sp
                        /**** EJEMPLO del objeto que se debe recibir ****/
                        // complete: 'Formulario cumplimentado correctamente',
                        // error: 'Hubo un problema',
                        // next: 'Siguiente',
                        // previous: 'Atrás',
                        // cancel: 'Cancelar',
                        // submit: 'FINALIZAR E IR AL PASO 2',
                        // required: 'Es obligatorio rellenar este campo',
                        // confirmCancel: '¿Estás seguro que quieres cancelar?',
                        // submitError: 'Por favor revise el formulario y corrija todos los errores.'
                    }
                }, 
                evalContext: {
                    // Funciones auxiliares
                    obtenerUrlContexto: obtenerUrlContexto,
                    validarCampo: functionValidadorRegex
                },
            }}
            onChange={props.onChange}
            submission={props.submission}
            onCustomEvent={props.onCustomEvent}
        />
    );
}